import { Component } from '@angular/core';
import { WizardSelectTypeComponent } from '@src/base-components/wizard/find-product/wizard-select-type';


@Component({
    selector: 'app-wizard-select-type-bellross',
    templateUrl: './wizard-select-type.html'
})
export class WizardSelectTypeComponentBellRoss extends WizardSelectTypeComponent {

}